<template>
  <div class="header-wrapper pagedetail animate fadeIn" v-if="page">
    <h1 class="pagedetail__title">กองผ้าป่า {{ form.title }}</h1>
    <div class="container">
      <div class="row">
        <div class="col-md-8 pd-sm-0">
          <page-card
                  ref="card"
                  :title="form.title"
                  :message="form.message"
                  :owner="form.owner"
                  :province="form.provinceObject"
                  :school="form.schoolObject"
                  :image="page.image"
                  :editing="editing"
                  :page="page"
                  @edit="edit"
                  @cancel="cancelEdit" />
        </div>

        <div class="col-md-4">
          <div class="block-border radius block shadow" v-if="editing">
            <page-form v-model="form" submit-button-text="บันทึก" @submit="update" />
          </div>
          <div v-else>
            <div class="block-border radius block shadow mb-15">
              <div class="flex flex-between">
                <div class="text-left">ยอดบริจาค
                  <br /><span class="text-remark" v-if="!page.data.total_product_price">ยังไม่มีเพื่อนร่วมบริจาค</span></div>
                <div class="text-right"><span class="amount">{{ (page.data.total_product_price || 0) | comma }}</span> บาท</div>
              </div>
              <hr />
              <div>
                <h4 class="text-center mt-15">แชร์กองผ้าป่าของคุณ</h4>
                <div class="share text-center">
                  <vue-goodshare-facebook
                          :page_url="url+'?v='+page.changed"
                          title_social="Facebook"
                          has_icon />
                  <share-line-button
                          :page_url="url+'?v='+page.changed"
                          title_social="Line"
                          has_icon />
                </div>
              </div>
            </div>
            <div class="block-border radius shadow mb-15 hide">
              <div class="" v-if="!page.data.total_product_price">
                <h3 class="text-center">
                  ร่วมเป็นคนแรกบริจาค<br />ให้กองผ้าป่านี้
                </h3>
                <hr />
              </div>

              <product-donate-choice
                      v-if="product"
                      :choices="[200, 500, 2500, 5000]"
                      :custom="true"
                      :defaults="500"
                      :minimum="20"
                      :product="product"
                      ref="donateChoice"
                      @change="amountChanged" />

              <product-donate-type :product="product" v-model="donateType" />

              <donor-info v-model="attributes.info" />

              <product-cart-action
                      v-if="product"
                      buy-now-text="บริจาค"
                      :stockAvailable="false"
                      :attributes="attributes"
                      :product="product"
                      :initialQuantity="1"
                      :addToCartButton="false"
                      :buyNowButton="false"
                      :style="{margin:0}"
                      ref="cartAction" />

              <div class="donate__wrapper">
                <button type="button" class="btn btn--purple" @click.prevent="donate">บริจาค</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <donor-list class="col-md-6" :page="page" v-if="page"/>
    </div>
  </div>
</template>

<script>
  import PageCard from '@/components/PageCard'
  import PageForm from '@/components/PageForm'
  import ProductDonateChoice from './ProductDonateChoice'
  import ProductDonateType from './ProductDonateType'
  import ProductCartAction from './ProductCartAction'
  import DonorInfo from './DonorInfo'
  import VueGoodshareFacebook from 'vue-goodshare/src/providers/Facebook'
  import ShareLineButton from './ShareLineButton'
  import DonorList from './DonorList'

  let moment = require('moment')
  moment.locale('th_TH')

  export default {
    components: {
      DonorInfo,
      ProductDonateChoice,
      ProductDonateType,
      ProductCartAction,
      PageForm,
      PageCard,
      VueGoodshareFacebook,
      ShareLineButton,
      DonorList
    },

    name: 'PageDetail',

    props: {
      page: {
        type: Object,
        default: null
      },
      canUpload: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        product: null,
        editing: false,
        showEditLink: true,
        attributes: {
          page: null,
          info: {
            name: null
          }
        },
        form: {
          title: '',
          message: '',
          province: '',
          provinceObject: null,
          school: '',
          schoolObject: null,
          owner: '',
          type: '',
          page: null
        },
        donateType: ''
      }
    },

    computed: {
      url () {
        if (this.page.code.startsWith('blank') || !this.page.code) {
          return `${window.location.origin}/pages/${this.page.id}`
        } else {
          return `${window.location.origin}/${this.page.code}`
        }
      }
    },

    created () {
      this.attributes.page = this.page
      this.initForm()
      this.getProduct()

      this.initDonateType()
    },

    methods: {
      initForm () {
        this.form.title = this.page.title || ''
        this.form.message = this.page.data.message || ''
        this.form.owner = this.page.data.owner || ''
        if (this.page.category_objects) {
          this.page.category_objects.forEach(category => {
            if (category.parent_id) {
              this.form.school = category.id
              this.form.schoolObject = category
            } else {
              this.form.province = category.id
              this.form.provinceObject = category
            }
          })
        }
        if (this.form.school) {
          this.form.type = '3'
        } else if (this.form.province) {
          this.form.type = '2'
        } else {
          this.form.type = '1'
        }
        this.form.page = this.page
      },

      initDonateType () {
        if (this.product.subscriptionAllowed && this.product.meta.default_donate_type) {
          this.donateType = this.product.meta.default_donate_type
        }
        if (!this.donateType) {
          this.donateType = 'onetime'
        }
      },

      donate () {
        if (!this.$refs.donateChoice.validate()) {
          return
        }
        this.$refs.cartAction.buyNow()
      },

      getProduct () {
        if (this.page.ref_obj_type === 'product' && this.page.ref_obj_id) {
          this.$http.get(`products/${this.page.ref_obj_id}`)
            .then(resp => {
              this.product = resp.body
              this.product.originalPrice = this.product.price
            })
            .catch(err => {
              console.log(err)
              this.$modal.show({
                title: 'เกิดข้อผิดพลาด',
                text: 'ไม่สามารถดึงข้อมูลได้'
              })
            })
        }
      },

      amountChanged (amount) {
        this.product.price = amount
      },

      update (data) {
        this.$modal.show({
          title: 'โปรดรอสักครู่',
          text: 'กำลังบันทึกข้อมูล...',
          okButton: false
        })

        const payload = JSON.parse(JSON.stringify(this.page))
        payload.title = data.title
        payload.data.message = data.message
        payload.data.owner = data.owner
        payload.categories = []
        if (data.province) {
          payload.categories.push(data.province)
        }
        if (data.school) {
          payload.categories.push(data.school)
        }
        payload.data = JSON.stringify(payload.data)
        this.$refs.card.captureCanvasToS3().then(result => {
          payload.image = result.image.split('?')[0]
          payload.share_image = result.shareImage.split('?')[0]

          this.$http.post(`pages/${this.page.id}`, payload)
            .then(resp => {
              this.cancelEdit()
              let modal = this.$modal
              let url = this.url

              window.FB.api('https://graph.facebook.com/', 'post', {
                id: url,
                scrape: true,
                // unimportant token
                access_token: 'EAACX6RdNZAkYBAB8jrduLNBTwMy7huVvkSVl5QyQdLe59PudGE5vZCTDjmnMKIMT5iYZAOaqO4tZAIRUt20XLg9AblU8kDSZCEsEF3N9TfsUqHXZC638wndY7YR8oqxLo7zjkxlm66Tc4Xw9NMZCYDUhyxhajID5WWjcMZBwRkKWtAZDZD'
              }, function (response) {
                console.log(response)
                modal.show({
                  title: 'สำเร็จ',
                  text: 'อัพเดทข้อมูลสำเร็จ'
                })
              })
            })
            .catch(err => {
              console.log(err)
              this.$modal.show({
                title: 'เกิดข้อผิดพลาด',
                text: `ไม่สามารถบันทึกข้อมูลได้`
              })
            })
        })
      },

      edit () {
        this.editing = true
      },

      cancelEdit () {
        this.editing = false
        this.$refs.card.editMode = false
      }
    }
  }
</script>

<style lang="scss" scoped>
.pagedetail {
  .container {
    background: transparent;
    padding-left: 15px;
    padding-right: 15px;
  }
  &__title {
    font-size: 2em;
    color: #fff;
    margin: 0 auto 30px;
    font-weight: 500;
    text-align: center;
    max-width: 1120px;
  }
  .amount {
    text-align: right;
    font-size: 30px;
    font-weight: 600;
    color: #000;
  }
}
/* On screens that are 600px or less, set the background color to olive */
@media screen and (max-width: 767px) {
  .pagedetail {
    &__title {
      font-size: 1.5em;
      margin: 30px auto 20px;
    }
    .pd-sm-0 {
      padding: 0;
    }
  }
}
.donate__wrapper {
  margin: 20px 0 0;

  .btn {
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// PageDetail.vue?79657b7e